import { render, staticRenderFns } from "./DatatableComponent.vue?vue&type=template&id=b4c033e6"
import script from "./DatatableComponent.vue?vue&type=script&lang=js"
export * from "./DatatableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports